// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-per-page {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3.2rem;
  margin-bottom: 3.2rem;
  max-width: 75%;
}
.results-per-page p {
  padding-right: 0.5rem;
}
@media screen and (width <= 719px) {
  .results-per-page {
    grid-template-columns: 1fr;
  }
}
@media screen and (width <= 500px) {
  .results-per-page p {
    padding-top: 0;
  }
}
.results-per-page .buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.results-per-page .buttons p {
  margin-right: 1.2rem;
}
@media screen and (width <= 719px) {
  .results-per-page .buttons p {
    margin-right: 0.6rem;
  }
}
@media screen and (width <= 719px) {
  .results-per-page .buttons {
    justify-content: space-between;
  }
}

.rpp-button {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
@media screen and (width <= 500px) {
  .rpp-button {
    padding-top: 1rem;
  }
}
.rpp-button button {
  min-width: 1rem !important;
  width: 5.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Tables/ResultsPerPage/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EAZF;IAaI,0BAAA;EACF;AACF;AACE;EACE;IACE,cAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;AAEI;EACE,oBAAA;AAAN;AAEM;EAHF;IAII,oBAAA;EACN;AACF;AAEI;EAbF;IAcI,8BAAA;EACJ;AACF;;AAGA;EACE,oBAAA;EACA,qBAAA;AAAF;AAEE;EAJF;IAKI,iBAAA;EACF;AACF;AACE;EACE,0BAAA;EACA,wBAAA;AACJ","sourcesContent":[".results-per-page {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 3.2rem;\n  margin-bottom: 3.2rem;\n  max-width: 75%;\n\n  p {\n    padding-right: 0.5rem;\n  }\n\n  @media screen and (width <= 719px) {\n    grid-template-columns: 1fr;\n  }\n\n  @media screen and (width <= 500px) {\n    p {\n      padding-top: 0;\n    }\n  }\n\n  .buttons {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    p {\n      margin-right: 1.2rem;\n\n      @media screen and (width <= 719px) {\n        margin-right: 0.6rem;\n      }\n    }\n\n    @media screen and (width <= 719px) {\n      justify-content: space-between;\n    }\n  }\n}\n\n.rpp-button {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n\n  @media screen and (width <= 500px) {\n    padding-top: 1rem;\n  }\n\n  button {\n    min-width: 1rem !important;\n    width: 5.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
